export default "__VITE_ASSET__Bz$qTSXV__"